<template>
  <table style="height: 100%; width: 100%">
    <tr>
      <td align="center" valign="center">
        <h1 class="title" style="font-size: 150px">404</h1>
        <h1>Sorry! Page not found</h1>
      </td>
    </tr>
    <tr>
      <td align="center" valign="center">
        After
        <span class="pink">{{ seconds }}</span>
        seconds, the browser will redirect to the index page.
        <br />
        If the page doesn't automatically redirect, please click this button.
        <br />
      </td>
    </tr>
    <tr>
      <td align="center" valign="center">
        <el-button
          class="btn btn-default btn-pink"
          @click="$router.push({ path: '/' })"
          >Go home</el-button
        >
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  data() {
    return {
      seconds: 5,
    };
  },
  created() {
    setInterval(() => (this.seconds -= 1), 1000);
  },
  updated() {
    if (!this.seconds) this.$router.push({ path: "/" });
  },
};
</script>

<style></style>
